import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { usePlatform } from '../context/PlatformContext';
import { useState } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { useBadgeCounts, DesktopNav, MobileMenu } from './navbar';

export const Navbar = () => {
  const { user, isAuthenticated, isAdmin, isArtist, isAgent, logout, testMode } = useAuth();
  const { cart } = useCart();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { notifCount, inboxCount } = useBadgeCounts(isAuthenticated);

  const showCart = isAuthenticated && !isAdmin && !isArtist && !isAgent;
  const dashboardLink = isAgent
    ? '/agent-dashboard'
    : (isArtist && !isAdmin ? '/artist-dashboard' : '/dashboard');
  const totalBadge = notifCount + inboxCount;

  const handleLogout = () => { logout(); navigate('/'); };

  // Fixed banners stack above the navbar: test-mode banner and/or early-access banner.
  const { ordersEnabled, loading: platformLoading } = usePlatform();
  const earlyAccessActive = !platformLoading && !ordersEnabled;
  const bannerCount = (testMode?.active ? 1 : 0) + (earlyAccessActive ? 1 : 0);
  const navTopOffset = bannerCount === 2 ? 'top-20' : bannerCount === 1 ? 'top-10' : 'top-0';

  return (
    <nav className={`fixed ${navTopOffset} left-0 right-0 z-50 glass`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo.png" alt="Tune4Tune" className="h-10 w-auto" />
            <span className="font-heading font-bold text-xl tracking-tight hidden sm:block">Tune4Tune</span>
          </Link>

          <DesktopNav
            user={user} isAuthenticated={isAuthenticated} isAdmin={isAdmin} isArtist={isArtist} isAgent={isAgent}
            showCart={showCart} cart={cart} dashboardLink={dashboardLink}
            notifCount={notifCount} inboxCount={inboxCount} onLogout={handleLogout}
          />

          {/* Mobile toggle */}
          <div className="md:hidden flex items-center gap-3">
            {isAuthenticated && totalBadge > 0 && (
              <Link to={`${dashboardLink}?tab=inbox`} className="relative">
                <MessageCircle className="w-5 h-5 text-[#A1A1AA]" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-lime text-black text-[10px] rounded-full flex items-center justify-center font-bold">{totalBadge > 9 ? '9+' : totalBadge}</span>
              </Link>
            )}
            <button className="p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-testid="mobile-menu-toggle">
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <MobileMenu
            isAuthenticated={isAuthenticated} isAdmin={isAdmin} isArtist={isArtist} isAgent={isAgent}
            onClose={() => setMobileMenuOpen(false)} onLogout={handleLogout}
          />
        )}
      </div>
    </nav>
  );
};

export default Navbar;
